export function shouldIntroduce({ path, introduction, hasMatches, hasLibraryPhotos }) {
  return (path === "/" || path === "/discoveries") &&
    (hasMatches || hasLibraryPhotos !== false) &&
    (introduction === "in_progress" || (!introduction && hasMatches))
}

export function permissionText(permission) {
  return {
    full: "Full Photos Access is available.",
    limited: "Selected Photos access only covers photos you choose. Full Access is needed to discover new photos across your library. You can change access in Settings or keep importing manually.",
    denied: "Photos access is off. You can allow Full Access in Settings or import selected photos manually.",
    restricted: "Photos access is restricted on this iPhone. Automatic import is unavailable. You can try manual selection.",
    not_determined: "Next, Apple will ask which photos Proximity can access. Automatic import needs Full Access.",
    unknown: "Photos access could not be determined."
  }[permission] || "Photos access could not be determined."
}

export function homeImportStatus(state, hasLibraryPhotos) {
  if (!state.enabled) return null
  if (state.permission !== "full") return {
    title: "Photo updates need your attention", description: permissionText(state.permission),
    settings: ["limited", "denied"].includes(state.permission)
  }
  if (state.running) return {
    title: "Finding your first matches",
    description: "Importing your photo dates and locations. You can invite friends while we work."
  }
  const error = state.error === "Background scheduling unavailable. Open the app to catch up." ? "" : state.error
  if (error) return { title: "Photo import couldn’t finish", description: error, retry: true }
  if (!state.last_completed) return {
    title: "Automatic photo updates are on",
    description: "Your first import hasn’t completed yet. You can invite friends now, or try importing again.", retry: true
  }
  if (!hasLibraryPhotos && state.uploaded === 0) return {
    title: "No photos with dates and locations found yet",
    description: "Automatic photo updates are on. We’ll check for eligible photos as you add them. You can invite friends now."
  }
  return { title: "Your photos are up to date", description: "We’ll keep checking for new photos. Invite your friends to find moments you shared." }
}
